export default __webpack_public_path__ + "static/media/workflow-ab-branching.42f98822.png";